<script>
    export default {
        name: "SocialShareButtonElement",
        data() {
            return {
                elementType: "social-share-button",
                buttonType: "social-share",
                socialNetworkClassMapping: {
                    facebook : "js-social-share-facebook",
                    twitter : "js-social-share-twitter",
                    linkedin : "js-social-share-linkedin",
                    pinterest: "js-social-share-pinterest"
                }
            }
        },
        computed: {
            getDefaultDataStructure () {
                return {
                    elementType: this.elementType,
                    elementId: this.elementId,
                    styles: null,
                    socialNetwork: "",
                    linkData: {},
                    itemVisibilitySettings: null
                }
            },
            getSocialNetworkOptions () {
                return this.socialNetworkClassMapping;
            },
            allSocialNetworkOptions () {
                let classes = [];

                for (let key in this.socialNetworkClassMapping) {
                    if (!this.socialNetworkClassMapping.hasOwnProperty(key)) {
                        continue;
                    }

                    classes.push(this.socialNetworkClassMapping[key]);
                }

                return classes;
            },

        },
        methods: {
            getSocialNetwork () {
                let socialNetwork = '';

                const nodeSocialNetworkClass = this.getKeyForMatchingClass(this.socialNetworkClassMapping,{defaultValue : ""});

                // console.log('Current node social network: ', nodeSocialNetworkClass);

                socialNetwork = nodeSocialNetworkClass ? nodeSocialNetworkClass : '';

                return socialNetwork;
            },
            setSocialNetwork (socialNetwork) {
                let data = {
                    newClass: this.socialNetworkClassMapping[socialNetwork],
                    classesToRemove: this.allSocialNetworkOptions
                };

                this.applyClass(data);
            },
            addListeners () {
                // overridden by PreviewSocialShareButtonElement
            },
            elementCreationCallback () {
                this.addListeners();
            }
        }
    }
</script>
